<template>
  <i-heroicons-outline-chevron-up v-if="isUp" class="h-5 w-5 inline" />
  <i-heroicons-outline-chevron-down v-else class="h-5 w-5 inline" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    isUp?: boolean;
  }>(),
  {
    isUp: true,
  }
);
</script>
